import assetPath from '/app/xinglets/upsell/campaign-page/src/assets/paypal.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')